@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.picking-exception-alert {
  margin-top: @space-8;
  margin-bottom: @space-0;
  width: 100%;
}
